import format from "date-fns/format";
import parse from "date-fns/parse";
import crypto from "crypto";
import config from "../config.json";
import React from "react";
import { getObjectFromStorage } from "./get-location/location-from-storage";
import { _getItemFromLocalDecrypted, _isMPINVerified } from "network-helper";
import { GUEST_USER } from "./Enums/jhh";
import sha256 from "crypto-js/sha256";
import { _getItemFromSession, _setItemInSession } from "./Helpers/SessionKeys";
import { _getItemFromLocal, _setItemInLocal } from "./LocalKeys";
import { v4 as uuidv4 } from "uuid";

export const parseQueryString = () =>
    [...new URLSearchParams(window.location.search).entries()]
        // This could be replaced with Object.fromEntries() when browser support is better.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
        // Adding a polyfill just for this doesn't seem worth it.
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

export const getCurrentLanguage = () => window.sessionStorage.getItem("language_name");

export const trimLowerCase = (value) => (value ? value.replace(/ /g, "").toLowerCase() || "" : "");

export const trimUpperCase = (value) => (value ? value.replace(/ /g, "").toUpperCase() || "" : "");

export function parseAndFormatDate(dateString, inputFormat = "dd/MM/yyyy hh:mm a", outputFormat = "MMM dd yyyy") {
    if (!dateString) return "";
    try {
        const date = parse(dateString, inputFormat, new Date());
        const outputDate = format(date, outputFormat);
        return outputDate;
    } catch (error) {
        return "";
    }
}

export const getStatusSince = (statusDate, t) => {
    if (!statusDate) return "";
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const week = day * 7;
    const month = day * 30;
    const year = month * 12;
    const timeMap = {
        [second]: "second",
        [minute]: "minute",
        [hour]: "hour",
        [day]: "day",
        [week]: "week",
        [month]: "month",
        [year]: "year",
    };
    const dateParts = statusDate.split(" ");
    dateParts[0] = dateParts[0].split("/").reverse().join("/");
    const parsedStatusDate = new Date(dateParts.join(" "));
    const timeDiff = Math.floor(new Date().getTime() - parsedStatusDate.getTime());
    let lastMatchKey = 0;
    Object.keys(timeMap).some((timeUnit) => {
        if (timeUnit > timeDiff) {
            return true;
        }
        lastMatchKey = timeUnit;
        return false;
    });
    const diffNum = Math.floor(timeDiff / lastMatchKey);
    let timeUnit = `${timeMap[lastMatchKey]}${diffNum > 1 ? "s" : ""}`;
    timeUnit = t(trimUpperCase(timeUnit));
    if (timeMap[lastMatchKey] && timeMap[lastMatchKey] === "year" && diffNum > 1) {
        return `${t("STATUS_AS_ON")} ${parseAndFormatDate(statusDate)} `;
    }
    return timeUnit ? `${diffNum} ${timeUnit} ${t("AGO")}` : "";
};

export function isObjectEmpty(obj) {
    /* istanbul ignore next */
    return Object.keys(obj || {}).length <= 0;
}

export const isObject = (error) => error instanceof Object;

export const resolvePromise = (data = {}) =>
    new Promise((resolve) => {
        resolve(data);
    });

export const asyncMemoize =
    /* istanbul ignore next */
    (_promise, keyName = "global") => {
        const cache = {};
        let cacheKey = "";
        const wrapped = async function (...params) {
            let resp = {};
            try {
                cacheKey = params.length > 0 ? `${keyName}-${JSON.stringify(params)}` : keyName;
                const cachedItem = cache[cacheKey];
                if (cachedItem) {
                    return resolvePromise(cachedItem);
                }
                resp = await _promise.apply(this, Array.prototype.slice.call(params, 0));
                if (isObject(resp) && (isObjectEmpty(resp) || resp.apiResponse === "failed")) {
                    resp = null;
                }
                if (!resp) {
                    return _promise(params);
                }
                cache[cacheKey] = resp;
                return resolvePromise(resp);
            } catch (e) {
                return _promise(params);
            }
        };
        const clearCache = (cacheKey) => {
            delete cache[cacheKey];
            return true;
        };
        return [wrapped, clearCache];
    };

export function dtFormat(date = null, _format = "yyyy-MM-dd") {
    if (!date) {
        return "";
    }
    const result = format(new Date(date), _format);
    return result;
}

export function capitalizeFirstChar(inputString = "") {
    /* istanbul ignore next */
    if (!inputString) {
        return inputString;
    }
    const str = inputString.charAt(0).toUpperCase() + inputString.slice(1).toLowerCase();
    return str.replace(".", "");
}

export const isDesktopScreen = () => document.documentElement.clientWidth >= 768;
export const isTabletScreen = () =>
    document.documentElement.clientWidth >= 768 && document.documentElement.clientWidth < 1024;

export const goesBack = (() => {
    let backClicked = false;
    return (action = null) => {
        if (action === null) return backClicked;

        backClicked = action;
        return action;
    };
})();
export const getKeyWord = (Id) => {
    if (Id === "mkt_survey_v1") {
        return "MKT";
    } else if (Id === "womens_day_survey") {
        return "WOMEN";
    } else if (Id === "sleep_survey") {
        return "SLEEP";
    }
};
export const getCatForGAEvent = (Id) => {
    if (Id === "mkt_survey_v1") {
        return "EmWise Survey";
    } else if (Id === "womens_day_survey") {
        return "WOMEN-QUIZ";
    } else if (Id === "sleep_survey") {
        return "SLEEP-QUIZ";
    } else {
        return Id;
    }
};

export const getTitle = (id, t) => {
    if (id === "mkt_survey_v1") {
        return t("EmWise_TITLE");
    } else if (id === "womens_day_survey") {
        return t("WOMENSDAY_QUIZ");
    } else if (id === "sleep_survey") {
        return t("SLEEPDAY_QUIZ");
    } else {
        return "";
    }
};

export const getHealthScoreWorkFlows = (workflow_id) => {
    return !!["breast_cancer_risk", "your_health_score"].includes(workflow_id);
};

export const getHealthStatus = (score, workflow_id) => {
    if (workflow_id === "your_health_score") {
        if (score >= 0 && score <= 4) {
            return ["Low", "rgb(217, 53, 81)"];
        } else if (score >= 5 && score <= 7) {
            return ["Intermediate", "rgb(253, 197, 10)"];
        } else if (score >= 8 && score <= 10) {
            return ["High", "rgb(52, 193, 119)"];
        }
    } else if (workflow_id === "breast_cancer_risk") {
        if (score >= 0 && score <= 4) {
            return ["Low", "rgb(52, 193, 119)"];
        } else if (score >= 5 && score <= 9) {
            return ["Intermediate", "rgb(253, 197, 10)"];
        } else if (score >= 10 && score <= 16) {
            return ["High", "rgb(217, 53, 81)"];
        }
    }
    return ["", ""];
};

export const getCountForRegistered = (id) => {
    return 0;
};
export const notesLengthDict = {
    DIABETES: 2,
    CVD: 3,
    PCOS: 6,
    DASS: 4,
};

export const TextBody = ({ text, references = [], t }) => {
    const array = text.split("\n");
    return (
        <div>
            {array.map((ele) => (
                <p>{ele}</p>
            ))}
            {references.length ? (
                <>
                    <span>*{t("REFERENCE")}</span>
                    <ol style={{ wordBreak: "break-word" }}>
                        {references.map((r) => (
                            <li>
                                <a href={r} target="_blank">
                                    {r}
                                </a>
                            </li>
                        ))}
                    </ol>
                </>
            ) : null}
        </div>
    );
};
export const scrollToBottom = (message) => {
    if (message.current) {
        // console.log("message.current", message.current);
        message.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
};
export const appStorage = {
    /* istanbul ignore next */

    setItem(key, value) {
        window.sessionStorage.setItem(key, value);
    },
    getItem(key) {
        return window.sessionStorage.getItem(key);
    },
    removeItem(key) {
        return window.sessionStorage.removeItem(key);
    },
    clearAllAnswer() {
        const allKeys = Object.keys(window.sessionStorage);
        const valueDeleteForKeys = ["language_name"];
        allKeys.forEach((keyName) => {
            if (!valueDeleteForKeys.includes(keyName)) {
                this.removeItem(keyName);
            }
        });
    },

    resetSurveyData() {
        const allKeys = Object.keys(window.sessionStorage);
        const valueDeleteForKeys = ["covid_user_id", "language_name", "covid_source_user_id", "covid_source_id"];
        allKeys.forEach((keyName) => {
            if (!valueDeleteForKeys.includes(keyName)) {
                this.removeItem(keyName);
            }
        });
    },
};

export const localStorage = {
    setItem(key, value) {
        /* istanbul ignore next */
        if (!window.localStorage) {
            appStorage.setItem(key, value);
            return;
        }
        window.localStorage.setItem(key, value);
    },
    getItem(key) {
        /* istanbul ignore next */
        if (!window.localStorage) {
            return appStorage.getItem(key);
        }
        return window.localStorage.getItem(key);
    },
};

export const hasGooglePlacesSdk = () => window.google;

export const firstSuccessfulPromise = (promiseGenerators, hasResult = (val) => Boolean(val), initialValue = null) =>
    promiseGenerators.reduce(
        (promise, promiseGenerator) => promise.then((value) => (hasResult(value) ? value : promiseGenerator())),
        Promise.resolve(initialValue)
    );

export const isMobile = {
    Android() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any() {
        return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
    },
};

export function trimToLimit(value = "", charLimit) {
    if (!value) {
        return value;
    }
    if (value.length > charLimit) {
        const str = `${value.substring(0, charLimit)} ...`;
        return str;
    }
    return value;
}

export const isMobileDevice = () =>
    navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone|iPad|iPod/i);

export const formatNumber = (num) => {
    try {
        return num.toLocaleString("en-IN");
    } catch (e) {
        /* istanbul ignore next */
        return num;
    }
};

export const prop = (key) => (obj) => obj[key];

export const logError = (e) => console.log(`ERROR :: ${e}`);

export const getTermsURL = (sourceID) => {
    // if (trimLowerCase(sourceID) === 'myjioapp') return '/terms/terms.html';
    // if (trimLowerCase(sourceID) === 'emp_xp') return null;
    // return '/terms/index.html';
    return config.envBaseUrl + "jiohealthhub/tnc";
};
export const getPrivacyURL = (sourceID) => {
    // if (trimLowerCase(sourceID) === 'myjioapp') return '/privacy/privacy.html';
    // if (trimLowerCase(sourceID) === 'emp_xp') return null;
    // return '/privacy/index.html';
    return config.envBaseUrl + "jiohealthhub/pp";
};
export const getFooterLinks = (sourceID) => {
    const urlLinks = [];
    const privacyLink = getPrivacyURL(sourceID);
    const termLink = getTermsURL(sourceID);
    if (privacyLink) {
        urlLinks.push({ key: "Privacy", value: privacyLink });
    }
    if (termLink) {
        urlLinks.push({ key: "Terms and Conditions", value: termLink });
    }
    return urlLinks;
};

export const extractDateFromDateTime = (dateTime) => {
    const day = dateTime.getDate();
    const month = dateTime.getMonth() + 1;
    const year = dateTime.getFullYear();

    return `${("00" + day).slice(-2)}/${("00" + month).slice(-2)}/${year}`;
};

export const countQuestionsToBeShown = (questions, workflowId) => {
    let nonDependentLen = questions.filter((q) => !q.dependencies.length).length;
    if (_isMPINVerified()) {
        nonDependentLen = nonDependentLen - getCountForRegistered(workflowId);
    }
    let dependQuesCount = 0;
    for (const question of questions) {
        if (question.dependencies.length) {
            let shouldCount = true;
            for (const dependency of question.dependencies) {
                if (dependency.condition === "present") {
                    const selectedOptionId = getObjectFromStorage(dependency.question);
                    if (selectedOptionId && !dependency.options.includes(selectedOptionId)) {
                        shouldCount = false;
                        break;
                    }
                } else if (dependency.condition === "absent") {
                    const selectedOptionId = getObjectFromStorage(dependency.question);
                    if (selectedOptionId && dependency.options.includes(selectedOptionId)) {
                        shouldCount = false;
                        break;
                    }
                }
            }
            if (shouldCount) {
                dependQuesCount++;
            }
        }
    }
    return nonDependentLen + dependQuesCount;
};
export const disableEditQuestions = (questions) => {
    let disableEditArray = [];
    for (const question of questions) {
        for (const dependency of question.dependencies) {
            if (dependency.condition === "present" || dependency.condition === "absent") {
                disableEditArray.push(dependency.question);
            }
        }
    }
    return disableEditArray;
};

export const stringToBase64 = (str) => {
    // Convert the string to its hexadecimal representation
    let hex = "";
    for (let i = 0; i < str.length; i++) {
        hex += str.charCodeAt(i).toString(16);
    }

    // Convert the hexadecimal string to its base64 representation
    let base64 = btoa(
        hex
            .match(/\w{2}/g)
            .map(function (a) {
                return String.fromCharCode(parseInt(a, 16));
            })
            .join("")
    );

    return base64;
};

export const setLeadId = (leadId = null) => {
    const storedExpirationTime = parseInt(_getItemFromLocal("_jhh_lead_id_expiry"));

    //All following condition denotes either lead is expired, doesn't exist or new lead is is available
    if (
        !_getItemFromLocal("_jhh_lead_id") ||
        !_getItemFromLocal("_jhh_lead_id_expiry") ||
        Date.now() > storedExpirationTime ||
        leadId
    ) {
        let userId = GUEST_USER;

        if (_isMPINVerified()) {
            const { healthhub_id } = JSON.parse(_getItemFromLocalDecrypted("_cp"));
            userId = healthhub_id;
        }

        const datenow = Date.now();

        const str = leadId ? leadId : sha256(userId + datenow.toString() + uuidv4());
        const expirationTime = datenow + config.leadExpireInMins * 60 * 1000;

        //set new lead and expiration time
        _setItemInLocal("_jhh_lead_id", str);
        _setItemInLocal("_jhh_lead_id_expiry", expirationTime);

        //Remove Lead id from URL
        const url = new URL(window.location.href);
        url.searchParams.delete("lead_id");
        window.history.replaceState(null, "", url.toString());
    } else {
        //Time should be updated regularly to mark user active
        const datenow = Date.now();
        const expirationTime = datenow + config.leadExpireInMins * 60 * 1000;
        _setItemInLocal("_jhh_lead_id_expiry", expirationTime);
    }
};
